import * as React from "react"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
  type ToastActionElement,
  type ToastProps,
} from "@/components/ui/toast"
import { useToast } from "@/components/ui/use-toast"

/**
 * Extended toast properties that include additional metadata
 */
interface ToasterToast extends Omit<ToastProps, 'title'> {
  id: string
  title?: string
  description?: React.ReactNode
  action?: ToastActionElement
}

/**
 * A toast component that renders a list of toasts
 * @returns A React component that renders a list of toasts
 */
export function Toaster(): React.ReactElement {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(({ id, title, description, action, ...props }: ToasterToast) => {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
} 